import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  EDIT_MEDICATION_REQUEST,
  EDIT_MEDICATION_SUCCESS,
  EDIT_MEDICATION_ERROR,
  SET_TOAST
} from "../../actions";
import {IMedication, ToastType} from "../../../utils/interfaces";

function* workerEditMedication({
  type,
  payload: { medicationId, patientId, updatedMedication },
}: {
  type: string;
  payload: {
    medicationId: any;
    patientId: any;
    updatedMedication: IMedication;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.editMedication, patientId, medicationId, updatedMedication);

    yield put({
      type: EDIT_MEDICATION_SUCCESS,
      payload: { defaultMedications: data }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Medication was edited successfully",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: EDIT_MEDICATION_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherEditMedication() {
  yield takeLatest(EDIT_MEDICATION_REQUEST, workerEditMedication);
}
